export default __webpack_public_path__ + "static/media/040_tunnel.first.4863b99b.webp";